import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class CloverTechnologiesService {
  constructor(private http: HttpClient) {}

  public getCloverTechnologies(): Promise<string[]> {
    return this.http.get<string[]>(`${environment.apiUrls.cloverTechnologies}`).toPromise();
  }
}
